import React from 'react';

class TextInput extends React.Component {
  render() {
    let clearField;

    if (this.props.value) {
      clearField = (
        <span className="input-icon-wrapper">
          <span onClick={this.props.handleClear} className="clear-field icon clickable">
            <img src="https://cdn-assets.alltrails.com/assets/icons/thiccPlusIcon.png" />
          </span>
        </span>
      );
    }

    return (
      <div className="form-group">
        <div className="text-input-wrapper">
          <input
            className="text-input"
            disabled={this.props.disabled}
            type="text"
            value={this.props.value}
            name={this.props.name}
            placeholder={this.props.placeholder}
            onChange={this.props.onChange}
          />
          {clearField}
        </div>
      </div>
    );
  }
}

export { TextInput };
